module.exports = __webpack_public_path__ + "img/error1.685d97eb.png";